import { GenericObject, Nullable } from '@dxb-web-ui-framework/common/types';
import { formatAmount } from '@dxb-web-ui-framework/common/utils/Math';
import { stringToDate } from '@dxb-web-ui-framework/common/utils/Date';
import { Box } from '@dxb-web-ui-framework/design-system';
import React from 'react';
import { TransactionOrderStatusChip, TransactionStatusChip } from '../../../../../../transaction/src/components';
import { CTACellRendererConfig } from '../../types';

const formatAmountTransformer =
  (
    dataValueToMap: string,
    dataCurrencyToMap: string,
    minimumFractionDigits: number = 2,
    numberFormat?: Nullable<string>,
  ) =>
  (data: GenericObject) =>
    formatAmount(data[dataValueToMap], data[dataCurrencyToMap], minimumFractionDigits, numberFormat);

const stringToDateTransformer =
  (formatExp: string = 'dd/MM/yyyy', dataDateToMap: string, locale?: Nullable<string>, timezone?: string) =>
  (data: GenericObject) =>
    stringToDate({ date: data[dataDateToMap], formatExp, localeName: locale, tz: timezone });

const transactionStatusTransformer = (data: GenericObject) => (
  <TransactionOrderStatusChip statusSerialNumber={data.status} />
);

const activityLogStatusTransformer = (data: GenericObject) => <TransactionStatusChip id={data.status} />;

const ctaTableTransformer =
  (config: (rowData: any, cb: Function, t: Function) => CTACellRendererConfig[], callback: Function, t: Function) =>
  (data: any) =>
    (
      <Box display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
        {config(data, callback, t).map(({ Component, icon, items, children, props }, index) => (
          <Component key={index} {...(props || {})} icon={icon} items={items} children={children} />
        ))}
      </Box>
    );

export {
  formatAmountTransformer,
  stringToDateTransformer,
  transactionStatusTransformer,
  ctaTableTransformer,
  activityLogStatusTransformer,
};
